import { render, staticRenderFns } from "./Advances.vue?vue&type=template&id=1c25c364&scoped=true"
import script from "./Advances.vue?vue&type=script&lang=js"
export * from "./Advances.vue?vue&type=script&lang=js"
import style0 from "./Advances.vue?vue&type=style&index=0&id=1c25c364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c25c364",
  null
  
)

export default component.exports